import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';

const BugReportsIndex      = () => import('./BugReportsIndex.vue');
const BugReportCreate      = () => import('./BugReportCreate.vue');
const BugReportDetail      = () => import('./BugReportDetail.vue');
const BugReportLabelManager = () => import('./BugReportLabelManager.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/bug-reports'),
      name: 'bug_reports',
      meta: {
        permissions: ROLES,
      },
      component: BugReportsIndex,
    },
    {
      path: frontendURL('accounts/:accountId/settings/bug-reports/create'),
      name: 'bug_report_create',
      meta: {
        permissions: ROLES,
      },
      component: BugReportCreate,
    },
    {
      path: frontendURL('accounts/:accountId/settings/bug-reports/labels'),
      name: 'settings_bug_report_labels',
      meta: {
        permissions: ['administrator'],
      },
      component: BugReportLabelManager,
    },
    {
      path: frontendURL('accounts/:accountId/settings/bug-reports/:reportId'),
      name: 'bug_report_detail',
      meta: {
        permissions: ROLES,
      },
      component: BugReportDetail,
      props: true,
    },
  ],
};
